import React from 'react';
import { GenericAlphaNumericInput } from 'web-ui-components/lib/data/capture';
import { GenericFieldWrapper } from 'web-ui-components/lib/layout/fieldWrappers';
import { Field } from 'react-final-form';
import { Content } from '../../../infrastructure/content';
import PropTypes from '../../../types';
import { isValidGlobalBehaviour } from '../../../utils/validation';

const required = (value) =>
  isValidGlobalBehaviour(value && value.trim(), 'alphanumericSpace') ? undefined : 'Required';

const RegisteredName = ({ maxCharacters, isSubmitted, onChange }) => (
  <Content>
    {({ registeredCompanyName, registeredError, registeredBusinessHelpText }) => (
      <Field name="registeredName" subscription={{ touched: true, error: true }}>
        {({ meta: { touched, error } }) => (
          <GenericFieldWrapper
            name="registeredName"
            title={registeredCompanyName}
            validationMessage={(isSubmitted || touched) && !!error && registeredError}
            description={registeredBusinessHelpText}
          >
            <Field name="registeredName" component="input" validate={required}>
              {({ input }) => (
                <GenericAlphaNumericInput
                  id="registeredName"
                  type="text"
                  {...input}
                  maxLength={maxCharacters}
                  onChange={(changedValue) => {
                    if (changedValue.value && changedValue.value.length > maxCharacters) return;
                    input.onChange(changedValue.value);
                    onChange('registeredName', changedValue.value);
                  }}
                  hasValidationEnabled={(isSubmitted || touched) && !!error}
                />
              )}
            </Field>
          </GenericFieldWrapper>
        )}
      </Field>
    )}
  </Content>
);

RegisteredName.propTypes = {
  maxCharacters: PropTypes.number
};

RegisteredName.defaultProps = {
  maxCharacters: 40
};

export default RegisteredName;
